import { FormHelperText, Typography } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import ContentTitle from "components/common/ContentTitle";
import Steper from "components/common/Steper";
import ButtonController from "components/request-document/components/ButtonController";
import {
  Bagde,
  StyledTableCell,
  TableRowHead,
  useStyles,
} from "components/request-document/components/Commons";
import { useExtendsionFormPartB } from "components/smart-visa-extension/useExtendsionForm";
import { EXTENSION_DOCUMENT_STEP } from "libs/configs/constant";
import { getErrorMessage, isError } from "libs/utils/form";
import { get } from "lodash-es";
import React from "react";
import { useSelector } from "react-redux";
import { selectMasterData } from "redux/modules/masterSlice";

export default function PartB() {
  const classes = useStyles();
  const masterData = useSelector(selectMasterData);
  const { formik, onSaveDraft, isSmartS } = useExtendsionFormPartB();

  const startupSectorsConfig = get(masterData, "startupSectorsConfig", []);
  const activitiesConfig = get(masterData, "activitiesConfig", []);
  const startupStageConfig = get(masterData, "startupStageConfig", []);

  const isRenderSelectSmart = false;

  return (
    <div className={classes.root}>
      <ContentTitle
        title="APPLICATION FOR SMART VISA EXTENSION"
        subTitle="SMART VISA EXTENSION"
      />
      <Steper isExtend currentStep={0} stepInfo={EXTENSION_DOCUMENT_STEP} />
      <form onSubmit={formik.handleSubmit}>
        <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <StyledTableCell colSpan={7}>
                  <Typography variant="h6" className={classes.tableTitle}>
                    Part B : Targeted industries
                  </Typography>
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {!isSmartS && (
                <TableRow>
                  <StyledTableCell colSpan={6} align="start">
                    <div className={classes.cellContent}>
                      <Bagde number={1} />
                      <div className={classes.wrapField}>
                        <InputLabel>
                          {`For Smart Visa holder T, I and E, please choose the targeted industries most relevant to your company's activities`}
                        </InputLabel>
                        <div>
                          <FormControl
                            variant="outlined"
                            className={classes.formControl}
                            style={{ width: 550 }}
                          >
                            <InputLabel>Activities</InputLabel>
                            <Select
                              label="Activities"
                              name="activitiesId"
                              value={formik.values.activitiesId}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            >
                              {activitiesConfig.map((activities) => (
                                <MenuItem
                                  key={activities.activitiesId}
                                  value={activities.activitiesId}
                                >
                                  {activities.activitiesName}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                          <FormControl
                            variant="outlined"
                            className={classes.formControl}
                            style={{ width: 450 }}
                          >
                            <InputLabel>Sub activities</InputLabel>
                            <Select
                              label="Sub activities"
                              name="activitiesIdSub"
                              value={formik.values.activitiesIdSub}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            >
                              {activitiesConfig.map((activities) => (
                                <MenuItem
                                  key={activities.activitiesId}
                                  value={activities.activitiesId}
                                >
                                  {activities.activitiesName}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </div>
                      </div>
                    </div>
                  </StyledTableCell>
                </TableRow>
              )}
              {isSmartS && (
                <>
                  <TableRow>
                    <StyledTableCell colSpan={6} align="start">
                      <div className={classes.cellContent}>
                        <Bagde number={1} />
                        <InputLabel>
                          For Smart Visa holder S, please choose the startup
                          sectors/ targeted industries /startup stage most
                          relevant to your activities
                        </InputLabel>
                      </div>
                    </StyledTableCell>
                  </TableRow>
                  <TableRowHead>
                    <StyledTableCell colSpan={2} align="center">
                      <InputLabel>Startup Sectors</InputLabel>
                    </StyledTableCell>
                    <StyledTableCell colSpan={2} align="center">
                      <InputLabel>Targeted Industries</InputLabel>
                    </StyledTableCell>
                    <StyledTableCell colSpan={2} align="center">
                      <InputLabel> Startup Stage</InputLabel>
                    </StyledTableCell>
                  </TableRowHead>

                  <TableRow>
                    <StyledTableCell colSpan={2}>
                      <div className={classes.cellContent}>
                        <div className={classes.wrapField}>
                          <FormControl
                            variant="outlined"
                            className={classes.formControl}
                            error={isError("startupSecId", formik)}
                          >
                            <InputLabel>Selected Startup Sectors</InputLabel>
                            <Select
                              label="Selected Startup Sectors"
                              name="startupSecId"
                              value={formik.values.startupSecId}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            >
                              {startupSectorsConfig.map((startupSectors) => (
                                <MenuItem
                                  value={startupSectors.startupSecId}
                                  key={startupSectors.startupSecId}
                                >
                                  {startupSectors.startupSectorsName}
                                </MenuItem>
                              ))}
                            </Select>
                            <FormHelperText
                              error={isError("startupSecId", formik)}
                            >
                              {getErrorMessage("startupSecId", formik)}
                            </FormHelperText>
                          </FormControl>
                        </div>
                      </div>
                    </StyledTableCell>
                    <StyledTableCell colSpan={2}>
                      <div className={classes.cellContent}>
                        <div className={classes.wrapField}>
                          <FormControl
                            variant="outlined"
                            className={classes.formControl}
                            error={isError("activitiesId", formik)}
                          >
                            <InputLabel>
                              Selected Targeted Industries
                            </InputLabel>
                            <Select
                              label="Selected Targeted Industries"
                              name="activitiesId"
                              value={formik.values.activitiesId}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            >
                              {activitiesConfig.map((activities) => (
                                <MenuItem
                                  value={activities.activitiesId}
                                  key={activities.activitiesId}
                                >
                                  {activities.activitiesName}
                                </MenuItem>
                              ))}
                            </Select>
                            <FormHelperText
                              error={isError("activitiesId", formik)}
                            >
                              {getErrorMessage("activitiesId", formik)}
                            </FormHelperText>
                          </FormControl>
                        </div>
                      </div>
                    </StyledTableCell>
                    <StyledTableCell colSpan={2}>
                      <div className={classes.cellContent}>
                        <div className={classes.wrapField}>
                          <FormControl
                            variant="outlined"
                            className={classes.formControl}
                            error={isError("startupStageId", formik)}
                          >
                            <InputLabel>Selected Startup Stage</InputLabel>
                            <Select
                              label="Selected Startup Stage"
                              name="startupStageId"
                              value={formik.values.startupStageId}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            >
                              {startupStageConfig.map((startupStage) => (
                                <MenuItem
                                  value={startupStage.startupStageId}
                                  key={startupStage.startupStageId}
                                >
                                  {startupStage.startupStageName}
                                </MenuItem>
                              ))}
                            </Select>
                            <FormHelperText
                              error={isError("startupStageId", formik)}
                            >
                              {getErrorMessage("startupStageId", formik)}
                            </FormHelperText>
                          </FormControl>
                        </div>
                      </div>
                    </StyledTableCell>
                  </TableRow>
                </>
              )}
              {isRenderSelectSmart && (
                <TableRow>
                  <StyledTableCell colSpan={6} align="start">
                    <div className={classes.cellContent}>
                      <Bagde number={2} />
                      <div className={classes.wrapField}>
                        <InputLabel>
                          {`Please select the type of visa you wish to apply (only one answer is possible)`}
                        </InputLabel>
                        <div>
                          <FormControl
                            variant="outlined"
                            className={classes.formControl}
                            style={{ width: 650 }}
                          >
                            <InputLabel>
                              Please select the type of visa you wish to apply
                              (only one answer is possible)
                            </InputLabel>
                            <Select
                              label="SelectSmart"
                              name="SelectSmart"
                              value={formik.values.SelectSmart}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            >
                              {[
                                {
                                  id: "0",
                                  name: "Smart T",
                                },
                                {
                                  id: "1",
                                  name: `Smart T (Govem ment sponsor/ higher
                                  cducation institutions / specialized
                                  institutions / Alternative Dispute
                                  Resolution)`,
                                },
                                {
                                  id: "2",
                                  name: "Smart I",
                                },
                                {
                                  id: "3",
                                  name: "Smart E",
                                },
                                {
                                  id: "4",
                                  name: "Smart S (2-year visa)",
                                },
                                {
                                  id: "5",
                                  name: "Smart S (6-month visa)",
                                },
                                {
                                  id: "6",
                                  name: "Smart O",
                                },
                              ].map((smart) => (
                                <MenuItem key={smart.id} value={smart.id}>
                                  {smart.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </div>
                      </div>
                    </div>
                  </StyledTableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <ButtonController
          isExtend
          onClickSaveDraft={() => {
            onSaveDraft();
          }}
        />
      </form>
    </div>
  );
}
